/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<defs><rect pid="0" id="svgicon-menu-a" width="2" height="18" rx="1"/></defs><g _fill="none" fill-rule="evenodd"><g><use _fill="#FFF" xlink:href="#svgicon-menu-a"/><rect pid="1" _stroke="#008AFF" stroke-width="2" x="1" y="1" width="1" height="16" rx=".5"/></g><g transform="translate(6)" _stroke="#234357" stroke-width="2"><rect pid="2" x="1" y="1" width="12" height="1" rx=".5"/><rect pid="3" x="1" y="9" width="12" height="1" rx=".5"/><rect pid="4" x="1" y="17" width="12" height="1" rx=".5"/></g></g>'
  }
})
